var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.isLoading?'opacity: 1;':'opacity: 0; pointer-events: none;'),attrs:{"id":"load-screen"}},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }